import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { ROUTES } from '../lib/routes';
import { useAuth } from '../hooks/useAuth';

export const AuthGuard = ({ allowedRoles = [] }) => {
  const { user, profile, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-slate-400 font-medium animate-pulse">Checking access...</div>
      </div>
    );
  }

  // Not logged in
  if (!user) {
    return <Navigate to={ROUTES.PUBLIC.HOME} replace />;
  }

  // If roles are specified, check them
  if (allowedRoles.length > 0) {
    const userRoles = profile?.hahub_profile_roles?.map(r => r.hahub_roles?.name) || [];
    const hasPermission = allowedRoles.some(role => userRoles.includes(role));

    if (!hasPermission) {
      console.warn('Access denied: User lacks required role', { required: allowedRoles, current: userRoles });
      return <Navigate to={ROUTES.PUBLIC.HOME} replace />;
    }
  }

  return <Outlet />;
};